import * as React from 'react';
import { Translate } from '../../../shared/LanguageService';
import { IUnBookedOrderListItem } from '../Entities';
import { Table, Button } from 'react-bootstrap';
import UnBookedOrderListRow from './UnBookedOrderListRow';

interface IUnBookedOrderListProps {
    items: IUnBookedOrderListItem[];
    user: any;
}

const UnBookedOrderList = (props: IUnBookedOrderListProps) => {
    return (
        <Table className="order-table table-nopadding" hover responsive>
            <thead>
                <tr>
                    <th>{Translate('orders/list/bookings/header/order-number')}</th>
                    <th>{Translate('orders/list/bookings/header/broker-firm')}</th>
                    <th>{Translate('orders/list/bookings/header/recieved')}</th>
                    <th>{Translate('orders/list/bookings/header/ordered')}</th>
                    <th>{Translate('orders/list/bookings/header/address')}</th>
                    <th>{Translate('orders/list/bookings/header/preferred-date')}</th>
                    <th>{Translate('orders/list/bookings/header/locked')}</th>
                    <th>{Translate('orders/list/bookings/header/is-read')}</th>
                    <th></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.items &&
                    props.items.map((i: IUnBookedOrderListItem) => (
                        <UnBookedOrderListRow order={i} key={i.orderId} user={props.user} />
                    ))}
            </tbody>
        </Table>
    );
};

export default UnBookedOrderList;
